import moment from 'moment'
import { confirmation } from '@/utils/alert'
import bus from '@/utils/eventBus'
import { schTime } from './dataTimes'
import { get } from 'lodash'

const prepareShow = schedule => {
  return schedule
}

export default {
  doHide () {
    this.isShowActive = false
  },
  doDelete (item, msg) {
    this.currentEntity = item
    const message = {
      label: 'Excluir',
      title: 'Atenção',
      message: 'Deseja remover esta reserva <b>' + item.title + '</b>?',
      cancel: 'Cancelar'
    }
    confirmation(confirm => {
      if (!confirm) {
        return
      }

      this.doDeleteWithoutConfirmation(item)
    }, message.message, message.title, message.label, message.cancel)
  },
  doDeleteWithoutConfirmation (entity) {
    this.currentEntity = entity
    bus.$emit('do-delete-schedule', {status: true})
    this.$resource.delete(entity.id)
      .then(({data}) => {
        bus.$emit('do-created-schedule', {show: true})
        bus.$emit('do-delete-schedule', {status: false})
      })
  },
  doLoad () {
    this.$resource.get('')
      .then(({data}) => {
        this.schedules = prepareShow({...data})
      })
  },
  dtDay (dt) {
    moment.locale('pt-br')
    return moment(dt, 'YYYYMMDD').format('DD')
  },
  dtYear (dt) {
    moment.locale('pt-br')
    return moment(dt, 'YYYYMMDD').format('YYYY')
  },
  formatTime (time) {
    moment.locale('pt-br')
    return get(schTime, moment(time).format('HH:mm'), moment(time).format('HH:mm'))
  },
  dtMonth (dt) {
    moment.locale('pt-br')
    const mm = moment(dt, 'YYYYMMDD').format('MM')
    return moment.monthsShort('-MMM-', (mm - 1))
  },
  doActive (schedule) {
    this.selectedSchedule = schedule
    this.isShowActive = true
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/nexts/resources/methods.js